import { Component } from "react";
// @flow
import { withTranslation } from "react-i18next";

import { LoginFormContainer } from "./Common";

import { NovaButton } from "pstat-design-system/shared/Button";

class SSOLogin extends Component {
  static defaultProps = {
    delay: 1000,
    hardRedirect: true,
    isUserHasProxy: false
  };

  componentDidMount() {
    if (this.props.hardRedirect) {
      this.timeoutSubmit = setTimeout(
        () => this.autoSubmitForm(),
        this.props.delay
      );
    }
  }

  componentWillUnmount() {
    clearTimeout(this.timeoutSubmit);
  }

  autoSubmitForm() {
    // Auto-login only for non-proxied users
    if (!this.props.isUserHasProxy && !process.env.STORYBOOK) {
      document.getElementById("ssoLoginForm").submit();
    }
  }

  render() {
    const { t } = this.props;
    return (
      <LoginFormContainer
        id="ssoLoginForm"
        action={this.props.samlSettings.location}
        data-testid="ssoForm"
        method="POST"
      >
        <input
          required={false}
          value={this.props.samlSettings.samlRequest}
          type="hidden"
          id={"id_SAMLRequest"}
          name={"SAMLRequest"}
          data-testid="samlRequest"
        />
        <NovaButton
          focusBorderProps={{ width: "100%" }}
          width="100%"
          buttonStyle="nova"
        >
          {t("buttons.ssoLogin")}
        </NovaButton>
      </LoginFormContainer>
    );
  }
}

export default withTranslation()(SSOLogin);
